import { App } from 'vue';
import { createPinia } from 'pinia'

export default ({ app }: { app: App<any> }) => {
  app.use(createPinia())
}
